<template>
  <Layout>
    <section>
      <header>
        <h2>{{ 'Address Book' | t }}</h2>
      </header>
      <main>
        <router-view />
      </main>
    </section>
  </Layout>
</template>

<script>
import t from '../../main/i18n';
import Layout from '../components/Layout.vue';

export default {
  components: {
    Layout
  },
  filters: {
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.personal-details--address-book {
  border: 1px solid $color-gray-400;
  border-radius: 1.2rem;

  .form-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;

    @media (min-width: $screen-md) {
      gap: 2.4rem;
    }

    :deep(.slo-input.type-checkbox) {
      input {
        border: 1px solid $color-gray-400;
        border-radius: 0.4rem;

        &:checked {
          background-color: $color-blue-400;
          border-color: $color-blue-400;

          &:before {
            display: flex;
            align-items: center;
            justify-content: center;
            background-size: contain;
            top: 50%;
            left: 50%;
            margin: 0;
            background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="18px" height="18px"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>');
          }
        }
      }
    }
  }

  .form-footer {
    background-color: $color-gray-100;
    padding: 3.2rem;
    border-top: 1px solid $color-gray-400;
    border-radius: 0 0 1.2rem 1.2rem;
  }

  &--footer {
    border-top: 1px solid $color-gray-400;
    border-radius: 0 0 1.2rem 1.2rem;
  }

  &--address-form-fields {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;

    @media (min-width: $screen-md) {
      flex-direction: row;
    }

    & > * {
      flex: 1;
    }
  }

  .fade-up-enter, .fade-up-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  .fade-up-enter-active, .fade-up-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }

  .slo-modal {
    &-footer {
      > .slo-button {
        flex: 1;
      }
    }
  }

  .fixed-button-width {
    flex-basis: 84px;
  }
}
</style>
